import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=8705eb8e&scoped=true&"
import script from "./TableActions.vue?vue&type=script&lang=ts&"
export * from "./TableActions.vue?vue&type=script&lang=ts&"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=8705eb8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8705eb8e",
  null
  
)

export default component.exports